<div [ngSwitch]="phase" class="table-title">
    <ng-container i18n *ngSwitchCase="BaccaratPhase.WaitingForCroupier">Table closed</ng-container>
    <ng-container i18n *ngSwitchCase="BaccaratPhase.WaitingForPlayers">Waiting for players</ng-container>
    <ng-container i18n *ngSwitchCase="BaccaratPhase.ShoeChange">Shoe Change</ng-container>
    <div i18n *ngSwitchCase="BaccaratPhase.CardBurn">
        @if (totalToBurnCount) {
            Cards burned - {{ burnedCount }} / {{ totalToBurnCount }}
        } @else {
            Draw first card
        }
    </div>
    <ng-container i18n *ngSwitchCase="BaccaratPhase.NewRoundPreparation">New round preparation</ng-container>
    <ng-container i18n *ngSwitchCase="BaccaratPhase.BetsOpen">Bets open, wait</ng-container>
    <ng-container i18n *ngSwitchCase="BaccaratPhase.BetsClosed">Bets closed</ng-container>
    <ng-container *ngSwitchCase="BaccaratPhase.DealingCards">
        @if (nextCardPosition) {
            <ng-container i18n>Deal card</ng-container> -
            @if (
                nextCardPosition === CardPosition.PlayerFirstCard ||
                nextCardPosition === CardPosition.PlayerSecondCard ||
                nextCardPosition === CardPosition.PlayerThirdCard
            ) {
                <ng-container i18n>player</ng-container>
            } @else {
                <ng-container i18n>banker</ng-container>
            }
        } @else {
            <ng-container i18n>Stop dealing cards</ng-container>
        }
    </ng-container>
    <ng-container *ngSwitchCase="BaccaratPhase.RoundEnd">
        <ng-container i18n *ngIf="outcome === BaccaratOutcome.BankerWin">Banker win</ng-container>
        <ng-container i18n *ngIf="outcome === BaccaratOutcome.PlayerWin">Player win</ng-container>
        <ng-container i18n *ngIf="outcome === BaccaratOutcome.Tie">Tie</ng-container>
        - {{ winnerHandValue }}
    </ng-container>
    <ng-container i18n *ngSwitchCase="BaccaratPhase.RoundVoid">Round voided</ng-container>
    <ng-container i18n *ngSwitchCase="BaccaratPhase.RoundError">Error</ng-container>
    <ng-container i18n *ngSwitchDefault>Unknown baccarat phase</ng-container>
</div>
